import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOfficerBaseState, OFFICER_BASE_DETAILS_KEY } from './officer-details-store.state';

const state = createFeatureSelector<IOfficerBaseState>(OFFICER_BASE_DETAILS_KEY);

export const OfficerBaseState = createSelector(state, (state1: IOfficerBaseState) => state1);
export const loggedInOfficer = createSelector(state, (state1: IOfficerBaseState) => state1.loggedInOfficer);
export const loggedInOfficerAutoClearFilters = createSelector(state, (state1: IOfficerBaseState) => state1.loggedInOfficer?.autoClearFilters);
